import { ChangeEvent, FC, InputHTMLAttributes } from 'react';
import './radio-button.scss';

type RadioButtonProps = InputHTMLAttributes<HTMLInputElement> & {
    id: string;
    checked?: boolean;
    label?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void | (() => void);
};

const RadioButton: FC<RadioButtonProps> = ({ label, id, checked, onChange, ...props }) => {
    return (
        <span className='radio-button'>
            <input
                type='radio'
                id={`radio-button-${id}`}
                name='radio-group'
                checked={checked}
                onChange={onChange}
                {...props}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            {label && <label htmlFor={`radio-button-${id}`}>{label}</label>}
        </span>
    );
};

export default RadioButton;
